module.exports = __webpack_public_path__ + "img/GazEuropeen_80X30.a85514e1.png";